import React from 'react'
import "./pagenotfound.css"

const PageNotFound = () => {
    return (
        <div className='pagenotfound'>

            <div className='container'>
                <div className='top-heading'>404 Not Found</div>
                <div className="title">
                    <h1 className='heading'>Oops! Page Not Found</h1>
                    <p className='desc'>The Page you are looking for doesn't exist. Click button below to go to the homepage.</p>
                </div>
                <a href="/"><button className='backtohome-btn'>Back to Homepage</button></a>
            </div>
        </div>
    );
};

export default PageNotFound